// components/layouts/main
import SideMenu from "../sidemenu";
import { Row, Col, Breadcrumb, Drawer, Button, Tooltip } from "antd";
import { HomeOutlined, MenuOutlined } from "@ant-design/icons";
import { HelpCircle } from "lucide-react";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Animations from "../../animations/Animations";
import CDXSearchBar from "../searchbar";
import CDXTitleBar from "../titleBar";
import { useRouter } from "next/router";
import Link from "next/link";
import Constants from "../../data/constants";
import ICON_MAP from "../../data/iconMap";
import { useHistory, useParams } from "react-router-dom";
import { connect } from "react-redux";
import {
  logout,
  loadUserData,
  requestServerPost,
  selectPage,
  stepBack,
  updateGlobalSearch,
  selectBranch,
  selectBrand,
  requestServerGet,
} from "../../actions";
import DataHelper from "../../helpers/DataHelper";
import AppTour from "../../helpers/AppTour";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const MainLayout = (props) => {
  const router = useRouter();

  const history = useHistory();
  const {
    userdata,
    selectedPage,
    userToken,
    selectPage,
    id = "",
    selectBrand,
    selectBranch,
    selectedBrandData,
    selectedBranchData,
    navHistory,
    onBackClicked = () => {},
    updateGlobalSearch,
    requestServerGet,
  } = props;

  const { lang } = useProLanguage();
  const navT = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).nav || {};

  const routerParams = useParams();

  // const pathSnippets = router.pathname.split('/').filter(i => i);

  // const breadcrumbNameMap = {
  //   "/brand": 'Brand',
  //   "/branch": 'Branch',
  //   "/screen": 'Screen',
  //   "/campaign": 'Campaign',
  //   "/timeline": 'Timeline',
  //   "/layout": 'Layout',
  //   "/playlist": 'Playlist',
  //   "/media": 'Media',
  // };

  useEffect(() => {}, []);
  // useEffect(() => {
  //   if (navHistory.length > 0) {
  //     selectPage(navHistory[navHistory.length - 1].id)
  //   }
  // }, [navHistory])

  useEffect(() => {
    console.log("selectedPage " + JSON.stringify(selectedPage));
    updateGlobalSearch("");

    try {
      // console.log("params" + JSON.stringify(routerParams))
    } catch (e) {}

    if (id === "") throw "please provide id for main layout";

    // if (selectPage.id === Constants.LOGIN_PAGE) {

    //   selectBrand(null)
    // }

    const requiresBrandData = Constants.checkPageRequirements(id, "brand");
    const requiresBranchData = Constants.checkPageRequirements(id, "branch");

    if (selectedPage.id === Constants.LOGIN_PAGE) {
      selectBrand(null);
      selectBranch(null);
      console.log("LOGGIN OUT - reset brand and branch");
    } else if (selectedPage.id === Constants.BRAND_PAGE) {
      selectBrand(null);
    } else if (
      selectedPage.id === Constants.BRANCH_PAGE ||
      selectedPage == Constants.LICENSE_PAGE
    ) {
      console.log("reset branch");
      selectBranch(null);
    }
    // console.log("0selected page id " + id + " " + selectedPage.id + " " + (selectPage.id !== Constants.LOGIN_PAGE))
    if (
      selectedPage.id !== Constants.LOGIN_PAGE &&
      (!userdata || !userdata.token || !userdata.user || userdata.token == "")
    ) {
      // console.log("1selected page id " + selectedPage.id)

      if (
        id !== Constants.LOGIN_PAGE &&
        selectedPage.id !== Constants.LOGIN_PAGE
      ) {
        console.log("NO USER DATA : REDIRECTING TO LOGIN");
        selectPage(Constants.LOGIN_PAGE, null, false);
      }
    } else if (
      selectedPage.id !== Constants.LOGIN_PAGE &&
      selectedPage.id !== Constants.BRAND_PAGE &&
      userdata &&
      userdata.token &&
      userdata.user &&
      userdata.token !== "" &&
      !selectedBrandData &&
      requiresBrandData
    ) {
      if (DataHelper.logoutInProgress) return;
      if ("brandid" in routerParams) {
        requestServerGet(
          "get_brands",
          {},
          null,
          (response) => {
            const selectedBrand = response.data.find(
              (brand) => `${brand.BrandID}` === `${routerParams.brandid}`,
            );
            // console.log("sdfsdf " + JSON.stringify(selectedBrand))
            selectBrand(selectedBrand);

            if ("branchid" in routerParams) {
              requestServerGet(
                "get_branches",
                {},
                null,
                (response) => {
                  const selectedBranch = response.data.find(
                    (branch) =>
                      `${branch.BranchID}` === `${routerParams.branchid}`,
                  );
                  // console.log("sdfsdf selectedBranch" + JSON.stringify(selectedBranch))
                  selectBranch(selectedBranch);
                },
                userdata.token,
              );
            } else selectPage(Constants.BRANCH_PAGE);
          },
          userdata.token,
        );
      } else selectPage(Constants.BRAND_PAGE);
    } else if (
      selectedPage.id !== Constants.BRAND_PAGE &&
      selectedPage.id !== Constants.BRANCH_PAGE &&
      userdata &&
      userdata.token &&
      userdata.user &&
      userdata.token !== "" &&
      selectedBrandData &&
      !selectedBranchData &&
      requiresBranchData
    ) {
      if ("branchid" in routerParams) {
        requestServerGet(
          "get_branches",
          {},
          null,
          (response) => {
            const selectedBranch = response.data.find(
              (branch) => `${branch.BranchID}` === `${routerParams.branchid}`,
            );

            console.log("GETTIKNG");
            selectBranch(selectedBranch);
          },
          userdata.token,
        );
      } else selectPage(Constants.BRANCH_PAGE);
    } else if (selectedPage && selectedPage.id !== "" && history) {
      // if ((selectedPage.id !== Constants.BRAND_PAGE) && (selectPage.id !== Constants.LOGIN_PAGE)) {
      //   console.log("3selected page id " + id)
      //   console.log("3selected page id " + selectedPage.id + " " + Constants.LOGIN_PAGE + " " + (selectPage.id == Constants.LOGIN_PAGE))
      //   // if (!selectedBrandData)
      //   // selectPage(Constants.BRAND_PAGE);
      // }
      // else {
      const brandSection = selectedBrandData
        ? `${selectedBrandData.BrandID}/`
        : "";
      const branchSection = selectedBranchData
        ? `${selectedBranchData.BranchID}/`
        : "";

      console.log(
        "MainLayout comparing page id " + id + " ... " + selectedPage.id,
      );
      if (id !== selectedPage.id) {
        switch (selectedPage.id) {
          case Constants.LOGIN_PAGE:
            history.replace(`/${Constants.LOGIN_PAGE}`);
            break;
          case Constants.BRAND_PAGE:
            history.push(`/${Constants.BRAND_PAGE}`);
            break;
          case Constants.BRANCH_PAGE:
            if (selectedBrandData)
              history.push(`/${selectedBrandData.BrandID}/${selectedPage.id}`);
            break;
          case Constants.LICENSE_PAGE:
            if (selectedBrandData)
              history.replace(`/${selectedBrandData.BrandID}/license`);

            selectBranch(null);
            break;
          case Constants.BRAND_PLAYLIST_PAGE:
          case Constants.BRAND_MEDIA_PAGE:
          case Constants.BRAND_MEDIA_TRASH_PAGE:
          case Constants.PLAYLIST_PAGE:
            console.log("selectedPage.content  " + selectedPage.content);
            if (selectedPage.content && selectedPage.content.id) {
              history.push(
                `/${brandSection}${branchSection}${selectedPage.id}/${selectedPage.content.id}`,
              );
            } else {
              history.push(
                `/${brandSection}${branchSection}${selectedPage.id}`,
              );
            }
            break;

          case Constants.CAMPAIGN_PAGE:
            console.log("selectedPage.content  " + selectedPage.content);
            if (selectedPage.content && selectedPage.content.id) {
              if (selectedPage.content.timelineid) {
                history.push(
                  `/${brandSection}${branchSection}${selectedPage.id}/${selectedPage.content.id}/${selectedPage.content.timelineid}`,
                );
              } else {
                history.push(
                  `/${brandSection}${branchSection}${selectedPage.id}/${selectedPage.content.id}`,
                );
              }
            } else {
              history.push(
                `/${brandSection}${branchSection}${selectedPage.id}`,
              );
            }
            break;

          default:
            // const requiresBrand = Constants.checkPageRequirements(selectedPage.id, "brand");
            // const requiresBranch = Constants.checkPageRequirements(selectedPage.id, "branch");

            // if (selectedBrandData && selectedBranchData)
            history.push(`/${brandSection}${branchSection}${selectedPage.id}`);
            break;
        }
      }
      // }
    }
  }, [selectedPage]);

  const breadcrumbItems = [];

  const tourReady = !!(
    userdata &&
    userdata.token &&
    selectedBrandData &&
    selectedBranchData
  );

  const tourTooltip =
    (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).appTour?.tooltip ||
    "Product Tour";

  return (
    <>
      <AppTour isReady={tourReady} />
      <MainLayoutClass
        {...props}
        router={router}
        breadcrumbItems={breadcrumbItems}
        navT={navT}
      />
      {/* Floating "?" button — hidden for now (Help is available in the sidebar). */}
      <Tooltip title={tourTooltip} placement="left">
        <div
          id="pro-tour-help-btn"
          onClick={() => window.__startProTour && window.__startProTour()}
          style={{
            display: "none",
            position: "fixed",
            bottom: 28,
            right: 28,
            width: 44,
            height: 44,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
            color: "#ffffff",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow:
              "0 4px 14px rgba(99, 102, 241, 0.35), 0 2px 6px rgba(99, 102, 241, 0.2)",
            zIndex: 999,
          }}
        >
          <HelpCircle size={22} />
        </div>
      </Tooltip>
    </>
  );
};

// < 768: phone, sidebar hidden behind a drawer
// 768 - 1279: tablet, inline icon-only sidebar that can expand/collapse
// >= 1280: desktop, inline sidebar expanded by default (still collapsible)
const getSidebarCategory = (width) => {
  if (width < 768) return "mobile";
  if (width < 1280) return "tablet";
  return "desktop";
};

class MainLayoutClass extends React.Component {
  constructor(props) {
    super(props);
    const width = typeof window !== "undefined" ? window.innerWidth : 1280;
    const category = getSidebarCategory(width);
    this.state = {
      content: null,
      menuTitle: "",
      drawerOpen: false,
      sidebarCollapsed: category !== "desktop",
      isMobile: category === "mobile",
      sidebarCategory: category,
    };
  }

  onBackClick = () => {
    // console.log("back click")
    const {
      navHistory,
      onBackClicked = () => {},
      preventDefaultStepBack = false,
      selectPage,
      stepBack = () => {},
    } = this.props;
    onBackClicked();

    if (!preventDefaultStepBack) {
      stepBack();
      const lastPage = navHistory[navHistory.length - 1];
      if (lastPage) selectPage(lastPage.id, lastPage.content, false);
    }
  };

  handleResize = () => {
    const category = getSidebarCategory(window.innerWidth);
    this.setState((prev) =>
      category === prev.sidebarCategory
        ? { isMobile: category === "mobile" }
        : {
            isMobile: category === "mobile",
            sidebarCategory: category,
            sidebarCollapsed: category !== "desktop",
          },
    );
  };

  componentDidMount() {
    const { children, id, titleOverride, navT } = this.props;

    var title = titleOverride || (navT && navT[id]) || "";
    if (!title) title = Constants.getMenuTitleByID(id);
    this.setState({ content: children, menuTitle: title });
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  componentWillReceiveProps(props) {
    const { children, id, titleOverride, navT } = props;

    var title = titleOverride || (navT && navT[id]) || "";
    if (!title) title = Constants.getMenuTitleByID(id);
    this.setState({ content: children, menuTitle: title });
  }

  render() {
    const {
      renderBreadCrumb,
      id,
      showSideMenu = true,
      showSearchBar = true,
      showTitleBar = true,
      preventDefaultStepBack = false,
      showTopBarBrandLogo = true,
      selectedPage,
      selectedBranchData,
      selectedBrandData,
      style = {},
      ignorPadding = false,
      quietTitleBar = false,
    } = this.props;
    const { drawerOpen, isMobile } = this.state;
    const sideMenuData = Constants.SIDEMENU_BUTTONS.find(
      (btnData) => id == btnData.id,
    );

    // if (selectedPage != Constants.LOGIN_PAGE && selectedPage != Constants.BRAND_PAGE && selectedPage != Constants.BRANCH_PAGE) {
    //   if (!selectedBranchData || !selectedBrandData)
    //     return null
    // }

    const padding = ignorPadding
      ? "0px"
      : this.state.isMobile
        ? "16px"
        : "32px";
    var selectedSideMenuID = id;

    if (
      selectedSideMenuID === Constants.CAMPAIGN_CONTENT_CHANNEL_PAGE ||
      selectedSideMenuID === Constants.CAMPAIGN_CONTENT_PAGE
    ) {
      selectedSideMenuID = Constants.CAMPAIGN_PAGE;
    }

    return (
      <motion.div
        className="main-scroll-container"
        exit={{ opacity: 1, transition: { duration: 0 } }}
        initial="initial"
        animate="animate"
        whileHover="hover"
        whileTap="tap"
        style={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {showSearchBar ? (
          <div
            style={{ flexShrink: 0, position: "sticky", top: 0, zIndex: 1000 }}
          >
            <CDXSearchBar
              showBrandLogo={showTopBarBrandLogo}
              title={this.state.menuTitle}
              onMenuToggle={
                showSideMenu
                  ? isMobile
                    ? () => this.setState({ drawerOpen: true })
                    : () =>
                        this.setState((s) => ({
                          sidebarCollapsed: !s.sidebarCollapsed,
                        }))
                  : null
              }
            ></CDXSearchBar>
          </div>
        ) : null}
        {showSideMenu && isMobile ? (
          <Drawer
            placement="left"
            closable={false}
            onClose={() => this.setState({ drawerOpen: false })}
            visible={drawerOpen}
            bodyStyle={{ padding: 0, backgroundColor: "#1e293b" }}
            width={200}
          >
            <SideMenu
              selected={selectedSideMenuID}
              onNavigate={() => this.setState({ drawerOpen: false })}
            />
          </Drawer>
        ) : null}
        <Row key={id} type="flex" style={{ flex: 1, alignItems: "stretch" }}>
          {showSideMenu && !isMobile ? (
            <Col
              style={{
                width: this.state.sidebarCollapsed ? "64px" : "200px",
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                position: "sticky",
                top: "56px",
                height: "calc(100vh - 56px)",
                alignSelf: "flex-start",
                transition: "width 0.25s ease",
              }}
            >
              <SideMenu
                selected={selectedSideMenuID}
                collapsed={this.state.sidebarCollapsed}
              ></SideMenu>
            </Col>
          ) : null}

          <Col
            id="pro-content-area"
            flex={"1"}
            style={{
              width:
                showSideMenu && !isMobile
                  ? `calc(100% - ${this.state.sidebarCollapsed ? "64px" : "200px"})`
                  : "100%",
              display: "flex",
              flex: 1,
              minWidth: 0,
              backgroundColor: "#f8fafc",
              flexDirection: "column",
            }}
          >
            {showTitleBar ? (
              <CDXTitleBar
                onBackClicked={this.onBackClick}
                preventDefaultStepBack={preventDefaultStepBack}
                title={this.state.menuTitle}
                quiet={quietTitleBar}
                icon={sideMenuData ? ICON_MAP[sideMenuData.id] : null}
              >
                {renderBreadCrumb ? renderBreadCrumb() : null}
              </CDXTitleBar>
            ) : null}
            <div
              style={{
                width: "100%",
                flex: 1,
                minWidth: 0,
              }}
            >
              <motion.div
                key={id}
                variants={Animations.PAGE_ENTER}
                initial="initial"
                animate="animate"
                exit="exit"
                style={{ width: "100%", padding: padding, ...style }}
              >
                {this.state.content}
              </motion.div>
            </div>
          </Col>
        </Row>
      </motion.div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    userToken: state.userToken,
    selectedPage: state.selectedPage,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
    navHistory: state.navHistory,
  };
};

export default connect(mapStateToProps, {
  logout,
  loadUserData,
  selectPage,
  requestServerPost,
  stepBack,
  updateGlobalSearch,
  requestServerGet,
  selectBrand,
  selectBranch,
})(MainLayout);
